import React from 'react';
import { ToastContainer } from 'react-toastify';
import { Provider } from 'react-redux';

import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/styles/app.sass';
import Routes from './Routes';
import reduxStore from './store';

const App = () => {
  
  console.log('1 SurveyStud App loaded successfully! Deployment verified at:', new Date().toLocaleString());
  
  return (
    <Provider store={reduxStore}>
      <div className="App">
        <ToastContainer id="forToast" hideProgressBar />
        <Routes />
      </div>
    </Provider>
  );
};

export default App;
